import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserPreferences {
  multiCartEnabled: boolean;
  favoriteGroupsEnabled: boolean;
  showFavoritesOnHome: boolean;
}

interface SettingsState {
  multiCartEnabled: boolean;
  setMultiCartEnabled: (enabled: boolean) => void;
  favoriteGroupsEnabled: boolean;
  setFavoriteGroupsEnabled: (enabled: boolean) => void;
  showFavoritesOnHome: boolean;
  setShowFavoritesOnHome: (show: boolean) => void;
  /** True once the store has been hydrated from the server (/auth/me). Used to
   * gate the sync-to-server effect so the initial hydration does not PATCH
   * the same values back. */
  didHydrate: boolean;
  /** Replace state with server-side preferences without marking the store
   * dirty for the sync effect (it checks didHydrate + a payload hash). */
  hydrateFromServer: (prefs: UserPreferences) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      multiCartEnabled: false,
      setMultiCartEnabled: (enabled) => set({ multiCartEnabled: enabled }),
      favoriteGroupsEnabled: false,
      setFavoriteGroupsEnabled: (enabled) => set({ favoriteGroupsEnabled: enabled }),
      showFavoritesOnHome: false,
      setShowFavoritesOnHome: (show) => set({ showFavoritesOnHome: show }),
      didHydrate: false,
      hydrateFromServer: (prefs) => set({
        multiCartEnabled: prefs.multiCartEnabled,
        favoriteGroupsEnabled: prefs.favoriteGroupsEnabled,
        showFavoritesOnHome: prefs.showFavoritesOnHome,
        didHydrate: true,
      }),
    }),
    {
      name: 'vivatis-settings',
      partialize: (state) => ({
        multiCartEnabled: state.multiCartEnabled,
        favoriteGroupsEnabled: state.favoriteGroupsEnabled,
        showFavoritesOnHome: state.showFavoritesOnHome,
      }),
    },
  ),
);
